import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EncodeData } from 'src/app/shared/models/encode.model';
import { Partnership } from '../partnership.model';
import { PartnershipService } from '../partnership.service';

@Component({
  selector: 'ng-partnership-detail',
  templateUrl: './partnership-detail.component.html',
  styleUrls: ['./partnership-detail.component.css']
})
export class PartnershipDetailComponent implements OnInit {

  partinership:Partnership;
  isSpinnerLoading: boolean;

  constructor(public aRoute: ActivatedRoute,public navigator:Router,public partnershipServ:PartnershipService){
    this.partinership=new Partnership();
  }

  ngOnInit() {
    // this.partinership 
    this.isSpinnerLoading=true;
    this.partnershipServ.getObject('partnership').subscribe(partnership=>{
      this.isSpinnerLoading=false;
      this.partinership=partnership
    })
  }

  editPartinership(partinership:Partnership) {
    this.navigator.navigate(['/admin/partnership/edit'])
    .then(()=>this.partnershipServ.setObject(partinership,'partnership'))
  }
  
  tableProprieties(){
    return [
      'A',
      'B',
      'C',
      'D'
    ]
  }

}
